import React, { Component, PropTypes } from 'react';

import './Subheading.css';

export default class Subheading extends Component {
    static propTypes = {
        title: PropTypes.string.isRequired,
    }

    render() {
        return (
            <div className="subheading">
                <h1>{this.props.title}</h1>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./scripts/components/Common/Subheading.jsx